import { DashboardReview, DashboardReviewMetaData } from 'Interfaces/Review/DashboardReview';

export interface ReviewState {
    updatedReviewsBackup: DashboardReview[];
    updatedReviews: DashboardReview[];
    dashboardReviewsMetadata: DashboardReviewMetaData;
}

export interface ReviewLocation {
    reviewId: string;
    reviewerUUID: string;
}

export const reviewInitialState: ReviewState = {
    updatedReviewsBackup: [],
    updatedReviews: [],
    dashboardReviewsMetadata: {
        currentStrength: '-',
        needFocus: '-',
        averageTicketsScore: 0,
        completedReviewsCounter: 0,
        acknowledgedReviewsCounter: 0,
    },
};
